import { DateTimePickerTabs } from '@mui/x-date-pickers';
import styled from 'styled-components';

export const StyledDatePickerTabs = styled(DateTimePickerTabs)`
  && {
    height: 3rem;
    padding: 0 1.25rem;
    border-bottom: 1px solid
      ${({ theme }) => theme.palette.stroke.secondaryLight};

    .MuiTabs-flexContainer {
      gap: 0.5rem;
    }

    .MuiTabs-indicator {
      height: 3px;
      border-radius: ${({ theme }) =>
        `${theme.shape.buttonRadius.large} ${theme.shape.buttonRadius.large} 0 0`};
    }

    button {
      ${({ theme }) => theme.typography.p7};
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 3rem;
      padding: 0;

      svg {
        width: 1.25rem;
        height: 1.25rem;
        color: ${({ theme }) => theme.palette.primary.main};
      }
    }
  }
`;
